// Module
var code = "<svg width=\"9\" height=\"7\" viewBox=\"0 0 9 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M4.97296 1.18079L8.54453 5.94289C8.79174 6.27251 8.55655 6.74289 8.14453 6.74289L1.00139 6.74289C0.58937 6.74289 0.354177 6.27251 0.601391 5.94289L4.17296 1.18079C4.37296 0.914127 4.77296 0.914128 4.97296 1.18079Z\"/>\n</svg>\n";
// Exports
export default code;